import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutSteps = ({ shipping, confirmOrder, payment }) => {
    return (
        <div className="checkout-progress flex justify-center items-center mt-10 mb-10 w-full px-4">
            <div className="flex items-center w-full max-w-2xl">
                {/* Cart Step */}
                <Link to="/cart" className="flex flex-col items-center group">
                    <div className="w-10 h-10 rounded-full border-2 border-yellow-600 flex items-center justify-center bg-yellow-600 text-white font-bold transition-all shadow-lg shadow-yellow-600/20">
                        1
                    </div>
                    <span className="text-[10px] uppercase tracking-widest mt-2 font-bold text-yellow-600">Cart</span>
                </Link>

                <div className={`flex-1 h-px mx-4 ${shipping ? 'bg-yellow-600 shadow-[0_0_8px_rgba(212,175,55,0.4)]' : 'bg-gray-200'}`}></div>

                {/* Shipping Step */}
                <Link to="/shipping" className="flex flex-col items-center group">
                    <div className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-bold transition-all ${shipping ? 'border-yellow-600 bg-yellow-600 text-white shadow-lg shadow-yellow-600/20' : 'border-gray-200 text-gray-400 bg-white'}`}>
                        2
                    </div>
                    <span className={`text-[10px] uppercase tracking-widest mt-2 font-bold ${shipping ? 'text-yellow-600' : 'text-gray-400'}`}>Shipping</span>
                </Link>

                <div className={`flex-1 h-px mx-4 ${confirmOrder ? 'bg-yellow-600 shadow-[0_0_8px_rgba(212,175,55,0.4)]' : 'bg-gray-200'}`}></div>

                {/* Confirm Step */}
                <Link to="/orderconfrim" className="flex flex-col items-center group">
                    <div className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-bold transition-all ${confirmOrder ? 'border-yellow-600 bg-yellow-600 text-white shadow-lg shadow-yellow-600/20' : 'border-gray-200 text-gray-400 bg-white'}`}>
                        3
                    </div>
                    <span className={`text-[10px] uppercase tracking-widest mt-2 font-bold ${confirmOrder ? 'text-yellow-600' : 'text-gray-400'}`}>Confirm</span>
                </Link>
            </div>
        </div>
    );
};

export default CheckoutSteps;
